import { useEffect, useState } from "react";
import { AppShell } from "@/components/app/AppShell";
import { DocumentsPanel } from "@/components/DocumentsPanel";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Documents() {
  const { company } = useAuth();
  const [investors, setInvestors] = useState([]);
  useEffect(() => {
    if (!company) return;
    api.get(`/companies/${company.id}/investors`).then(({ data }) => setInvestors(data)).catch(() => {});
  }, [company]);
  return (
    <AppShell title="Documents" subtitle="Share investment documents securely">
      <p className="mb-4 max-w-2xl text-sm text-muted-foreground">Upload SAFEs, term sheets, cap tables, board decks and financials. Choose who can see each file. Investors can also share documents with you here.</p>
      {company && <DocumentsPanel companyId={company.id} investors={investors} />}
    </AppShell>
  );
}
